var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:_vm.pageColor},[(_vm.validationLoaded)?_c('router-view',{class:'app background-' + _vm.pageColor}):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }